const StateData = JSON.parse(sessionStorage.getItem("STATE_PARAM"));
const Config = StateData ? StateData.source : null;
export default Config;